module.exports = __webpack_public_path__ + "static/media/emv_mid.e88138e3.jpeg";